import { useMediaQuery } from '@pm/ui';
import {
  createContext,
  FunctionComponent,
  PropsWithChildren,
  use,
  useEffect,
  useState,
} from 'react';

type MainAppLayoutContextType = {
  sidebarOpen?: boolean;
  setSidebarOpen: (sidebarOpen: boolean) => void;
  isDesktop: boolean;
  mediaQueryLoading: boolean;
};

export const MainAppLayoutContext = createContext<MainAppLayoutContextType>({
  sidebarOpen: false,
  setSidebarOpen: () => {
    return;
  },
  isDesktop: false,
  mediaQueryLoading: true,
});

export const useMainAppLayout = () => use(MainAppLayoutContext);

export const MainAppLayoutProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>();
  const { matches: isDesktop, loading: mediaQueryLoading } =
    useMediaQuery('(min-width: 960px)');

  useEffect(() => {
    if (sidebarOpen === undefined && !mediaQueryLoading) {
      // eslint-disable-next-line react-x/set-state-in-effect -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
      setSidebarOpen(false);
    }
  }, [isDesktop, mediaQueryLoading, sidebarOpen]);

  return (
    <MainAppLayoutContext
      value={{
        sidebarOpen,
        setSidebarOpen,
        isDesktop,
        mediaQueryLoading,
      }}
    >
      {children}
    </MainAppLayoutContext>
  );
};
